var map = {
  "./BR/merchant3/contract/article_01.json": "36433",
  "./BR/merchant3/customer-registration/customer-contact-info/article_01.json": "59544",
  "./BR/merchant3/customer-registration/terms-conditions/article_01.json": "48074",
  "./BR/merchant3/customer-registration/terms-conditions/article_02.json": "28187",
  "./BR/merchant3/customer-registration/terms-conditions/article_03.json": "76792",
  "./BR/merchant3/customer-registration/terms-conditions/article_04.json": "41025",
  "./BR/merchant3/offers/article_01.json": "2794",
  "./BR/merchant3/offers/article_02.json": "66683",
  "./BR/merchant3/offers/article_03.json": "9496",
  "./BR/merchant3/offers/article_04.json": "32609",
  "./BR/merchant3/software/article_01.json": "4752",
  "./BR/merchant3/software/article_02.json": "60269",
  "./BR/merchant3/software/article_03.json": "20834",
  "./BR/merchant3/software/article_04.json": "26527",
  "./BR/merchant3/software/article_05.json": "89388",
  "./CO/merchant3/contract/article_01.json": "70979",
  "./CO/merchant3/customer-registration/customer-contact-info/article_01.json": "94682",
  "./CO/merchant3/customer-registration/terms-conditions/article_01.json": "71436",
  "./CO/merchant3/customer-registration/terms-conditions/article_02.json": "25945",
  "./CO/merchant3/customer-registration/terms-conditions/article_03.json": "21758",
  "./CO/merchant3/customer-registration/terms-conditions/article_04.json": "88723",
  "./CO/merchant3/customer-registration/terms-conditions/article_05.json": "48176",
  "./CO/merchant3/offers/article_01.json": "46212",
  "./CO/merchant3/offers/article_02.json": "71601",
  "./CO/merchant3/offers/article_03.json": "80566",
  "./CO/merchant3/software/article_01.json": "31698",
  "./CO/merchant3/software/article_02.json": "26403",
  "./EC/merchant3/contract/article_01.json": "28577",
  "./EC/merchant3/customer-registration/customer-contact-info/article_01.json": "28488",
  "./EC/merchant3/customer-registration/terms-conditions/article_01.json": "20314",
  "./EC/merchant3/customer-registration/terms-conditions/article_02.json": "23179",
  "./EC/merchant3/customer-registration/terms-conditions/article_03.json": "21768",
  "./EC/merchant3/customer-registration/terms-conditions/article_04.json": "32433",
  "./EC/merchant3/customer-registration/terms-conditions/article_05.json": "66294",
  "./EC/merchant3/offers/article_01.json": "68218",
  "./EC/merchant3/offers/article_02.json": "11499",
  "./EC/merchant3/offers/article_03.json": "2632",
  "./EC/merchant3/offers/article_04.json": "26289",
  "./EC/merchant3/software/article_01.json": "63840",
  "./EC/merchant3/software/article_02.json": "25597",
  "./MX/merchant3/contract/article_01.json": "74112",
  "./MX/merchant3/customer-registration/customer-contact-info/article_01.json": "52911",
  "./MX/merchant3/customer-registration/terms-conditions/article_01.json": "78867",
  "./MX/merchant3/customer-registration/terms-conditions/article_02.json": "54562",
  "./MX/merchant3/customer-registration/terms-conditions/article_03.json": "64269",
  "./MX/merchant3/customer-registration/terms-conditions/article_04.json": "89484",
  "./MX/merchant3/customer-registration/terms-conditions/article_05.json": "3327",
  "./MX/merchant3/offers/article_01.json": "20395",
  "./MX/merchant3/offers/article_02.json": "1178",
  "./MX/merchant3/offers/article_03.json": "61157",
  "./MX/merchant3/software/article_01.json": "21961",
  "./MX/merchant3/software/article_02.json": "55196",
  "./PA/merchant3/contract/article_01.json": "34",
  "./PA/merchant3/contract/article_02.json": "24339",
  "./PA/merchant3/customer-registration/customer-contact-info/article_01.json": "59209",
  "./PA/merchant3/customer-registration/terms-conditions/article_01.json": "11933",
  "./PA/merchant3/customer-registration/terms-conditions/article_02.json": "73856",
  "./PA/merchant3/customer-registration/terms-conditions/article_03.json": "65507",
  "./PA/merchant3/customer-registration/terms-conditions/article_04.json": "91694",
  "./PA/merchant3/customer-registration/terms-conditions/article_05.json": "78057",
  "./PA/merchant3/offers/article_01.json": "73205",
  "./PA/merchant3/offers/article_02.json": "51992",
  "./PA/merchant3/offers/article_03.json": "37691",
  "./PA/merchant3/software/article_01.json": "51715",
  "./PA/merchant3/software/article_02.json": "64338",
  "./PE/merchant3/contract/article_01.json": "75630",
  "./PE/merchant3/contract/article_02.json": "26703",
  "./PE/merchant3/customer-registration/customer-contact-info/article_01.json": "55685",
  "./PE/merchant3/customer-registration/terms-conditions/article_01.json": "57041",
  "./PE/merchant3/customer-registration/terms-conditions/article_02.json": "10692",
  "./PE/merchant3/customer-registration/terms-conditions/article_03.json": "79415",
  "./PE/merchant3/customer-registration/terms-conditions/article_04.json": "29594",
  "./PE/merchant3/customer-registration/terms-conditions/article_05.json": "19301",
  "./PE/merchant3/offers/article_01.json": "4353",
  "./PE/merchant3/offers/article_02.json": "80436",
  "./PE/merchant3/offers/article_03.json": "28743",
  "./PE/merchant3/offers/article_04.json": "71754",
  "./PE/merchant3/software/article_01.json": "11671",
  "./PE/merchant3/software/article_02.json": "11382",
  "./ZA/merchant3/contract/article_01.json": "84584",
  "./ZA/merchant3/customer-registration/customer-contact-info/article_01.json": "39447",
  "./ZA/merchant3/customer-registration/terms-conditions/article_01.json": "74075",
  "./ZA/merchant3/offers/article_01.json": "59939",
  "./ZA/merchant3/receipt/article_01.json": "58488",
  "./ZA/merchant3/software/article_01.json": "18049"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 58111;
